import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

const ProductFormBarcodes = ({ barcodes, setBarcodes }) => {
  const [newBarcode, setNewBarcode] = useState('');
  const [dupHint, setDupHint] = useState(null); // { name, product_id }

  // Real-time duplicate check (debounced) — purely informational; server still enforces.
  useEffect(() => {
    const trimmed = newBarcode.trim();
    if (trimmed.length < 3) { setDupHint(null); return; }
    const handle = setTimeout(async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await axios.get(API + '/products/check-duplicate', {
          headers: { Authorization: 'Bearer ' + token },
          params: { barcode: trimmed },
        });
        if (res.data && res.data.exists) {
          setDupHint(res.data.product || { name: 'another product' });
        } else {
          setDupHint(null);
        }
      } catch (e) {
        setDupHint(null);
      }
    }, 400);
    return () => clearTimeout(handle);
  }, [newBarcode]);

  const addBarcode = () => {
    const trimmed = newBarcode.trim();
    if (trimmed && !barcodes.includes(trimmed)) {
      setBarcodes([...barcodes, trimmed]);
      setNewBarcode('');
      setDupHint(null);
    }
  };

  const removeBarcode = (bc) => {
    setBarcodes(barcodes.filter(b => b !== bc));
  };

  return (
    <div className="space-y-2">
      <Label>Barcodes (Multiple)</Label>
      <div className="flex gap-2">
        <Input
          value={newBarcode}
          onChange={(e) => setNewBarcode(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); addBarcode(); } }}
          placeholder="Scan or enter barcode"
          className="flex-1"
          data-testid="product-barcode-input"
        />
        <Button type="button" variant="outline" onClick={addBarcode} size="sm" data-testid="product-barcode-add-btn">Add</Button>
      </div>
      {dupHint && (
        <p className="text-xs text-amber-700 bg-amber-50 border border-amber-200 rounded px-2 py-1" data-testid="product-barcode-dup-warning">
          ⚠ Barcode already mapped to another product (<span className="font-semibold">{dupHint.name}</span>)
        </p>
      )}
      {barcodes.length > 0 && (
        <div className="flex flex-wrap gap-1 mt-2">
          {barcodes.map((bc, idx) => (
            <span key={bc || `bc-${idx}`} className="inline-flex items-center gap-1 px-2 py-1 text-xs bg-blue-100 text-blue-800 rounded">
              {bc}
              <button type="button" onClick={() => removeBarcode(bc)} className="text-blue-600 hover:text-red-600">×</button>
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

export default ProductFormBarcodes;
